/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForAzureSecurityGraphOAuthProtocol extends models.ServiceAccountCredentialsBaseForAzureSecurityGraph {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForAzureSecurityGraphOAuthProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForAzureSecurityGraphOAuthProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForAzureSecurityGraphOAuthProtocol>): ServiceAccountCredentialsForAzureSecurityGraphOAuthProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsForAzureSecurityGraphOAuthProtocol(), model);
        ServiceAccountCredentialsForAzureSecurityGraphOAuthProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForAzureSecurityGraphOAuthProtocol>): ServiceAccountCredentialsForAzureSecurityGraphOAuthProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsForAzureSecurityGraphOAuthProtocol.newInstance(<ServiceAccountCredentialsForAzureSecurityGraphOAuthProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForAzureSecurityGraphOAuthProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsForAzureSecurityGraphOAuthProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForAzureSecurityGraphOAuthProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForAzureSecurityGraph.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForAzureSecurityGraphOAuthProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Application Secret. This is a required field.
     */
    application_secret: string;

}
